import React from "react";
import {
  Box,
  Flex,
  Link,
  Text,
  useColorMode,
  Container,
  Divider,
} from "@chakra-ui/react";
import { Link as RouterLink } from "react-router-dom";
import { useTranslation } from "react-i18next";

const Footer: React.FC = () => {
  const { colorMode } = useColorMode();
  const { t } = useTranslation();

  return (
    <Box as="footer" py={6} mt="auto" width="100%" bg="transparent">
      <Container maxW="container.lg" px={{ base: 6, md: 4 }}>
        <Box mx={{ base: 4, md: 8 }}>
          <Divider
            mb={6}
            borderColor={colorMode === "light" ? "gray.200" : "gray.600"}
          />
          <Flex
            direction={{ base: "column", md: "row" }}
            justify="space-between"
            align={{ base: "center", md: "flex-start" }}
            gap={4}
            width="100%"
          >
            <Text
              fontSize="sm"
              color={colorMode === "light" ? "gray.600" : "gray.300"}
            >
              © {new Date().getFullYear()} QazBilim.{" "}
              {t("footer.allRightsReserved", "All rights reserved.")}
            </Text>

            <Flex gap={6} wrap="wrap" justify="center">
              <Link
                as={RouterLink}
                to="/privacy-policy"
                fontSize="sm"
                color={colorMode === "light" ? "gray.600" : "gray.300"}
              >
                {t("footer.privacyPolicy", "Privacy Policy")}
              </Link>
              <Link
                as={RouterLink}
                to="/terms-of-use"
                fontSize="sm"
                color={colorMode === "light" ? "gray.600" : "gray.300"}
              >
                {t("footer.termsOfUse", "Terms of Use")}
              </Link>
              <Link
                as={RouterLink}
                to="/about"
                fontSize="sm"
                color={colorMode === "light" ? "gray.600" : "gray.300"}
              >
                {t("footer.aboutUs", "About Us")}
              </Link>
            </Flex>
          </Flex>
        </Box>
      </Container>
    </Box>
  );
};

export default Footer;
